import { render, staticRenderFns } from "./WelcomePageIndex.vue?vue&type=template&id=398af78e"
import script from "./WelcomePageIndex.vue?vue&type=script&lang=js"
export * from "./WelcomePageIndex.vue?vue&type=script&lang=js"
import style0 from "./WelcomePageIndex.vue?vue&type=style&index=0&id=398af78e&prod&lang=scss"
import style1 from "./WelcomePageIndex.vue?vue&type=style&index=1&id=398af78e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports